enum AssetType {
    Text = 0,
    Bool = 1,
    Integer = 2
}

const AssetTypeValue = {
    GetText: (typeNumber: number) => {
        return AssetType[typeNumber].valueOf()
    }
}

export default AssetTypeValue